export default __webpack_public_path__ + "img/show-password-icon.04fc96ce.svg";